// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"9a4dcff7","202":"4e36e4f2","209":"4b3493f7","230":"6ce11d0e","347":"13f908c0","385":"dcbf728a","551":"4a1ee12c","556":"19566948","565":"7569c176","811":"3552ef83","901":"61f61247","929":"f6ee53d7","956":"f1c274bb"}[chunkId] + ".chunk.js";
};